import { getKycTokens } from '@services/external/auth.api';
import React from 'react';
import { useQuery } from 'react-query';

function useSumSubSDK() {
  /**
   * Refresh token for SumSub SDK
   */
  const refreshSdkToken = React.useCallback(async () => {
    const res = await getKycTokens();
    return res.data.token;
  }, []);

  const {
    data: kycToken,
    refetch,
    remove,
    isLoading,
  } = useQuery(['kyc:token'], refreshSdkToken, {
    cacheTime: 0,
  });

  return { kycToken, refetch, remove, isLoading, refreshSdkToken };
}

export default useSumSubSDK;
